module.exports = __webpack_public_path__ + "static/media/valencia-13.06708833.jpg";